<div class="wrapper">

  <div class="row">

    <div class="col-sm-12">

      <div class="card bb-panel">

        <form [formGroup]="changePasswordForm" autocomplete="chrome-off" class="col-sm-12" role="form"
          aria-label="Change password form" [class.submitted]="submitted">

          <div class="form-group">
            <label for="current_password"><span aria-hidden="true" class="form-field-required-marker">
                *</span> {{ 'ACCOUNT.CURRENT_PASSWORD_LBL' | translate}}</label>
            <input id="current_password" [type]="hideCurrentPassword ? 'password' : 'text'" class="form-control"
              formControlName="current_password" role="textbox">
            <span class="eye-pos">
              <button type="button" class="eye-toggle" (click)="hideCurrentPassword = false"
                *ngIf="hideCurrentPassword" aria-label="Show current password">
                <mat-icon class="material-symbols-outlined eye" aria-hidden="true">
                  visibility_off
                </mat-icon>
              </button>
              <button type="button" class="eye-toggle" (click)="hideCurrentPassword = true"
                *ngIf="!hideCurrentPassword" aria-label="Hide current password">
                <mat-icon class="material-symbols-outlined eye" aria-hidden="true">
                  visibility
                </mat-icon>
              </button>
            </span>
            <div *ngIf="submitted && form.current_password.errors" class="invalid-feedback">
              <div *ngIf="form.current_password.errors.required" role="alert">
                {{ 'ACCOUNT.CURRENT_PASSWORD_REQURIED' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="new_password"><span aria-hidden="true" class="form-field-required-marker">
                *</span> {{ 'ACCOUNT.NEW_PASSWORD_LBL' | translate}}</label>
            <input id="new_password" [type]="hide ? 'password' : 'text'" class="form-control"
              formControlName="new_password" role="textbox">
            <span class="eye-pos">
              <button type="button" class="eye-toggle" (click)="hide = false" *ngIf="hide"
                aria-label="Show new password">
                <mat-icon class="material-symbols-outlined eye" aria-hidden="true">
                  visibility_off
                </mat-icon>
              </button>
              <button type="button" class="eye-toggle" (click)="hide = true" *ngIf="!hide"
                aria-label="Hide new password">
                <mat-icon class="material-symbols-outlined eye" aria-hidden="true">
                  visibility
                </mat-icon>
              </button>
            </span>
            <div *ngIf="submitted && form.new_password.errors" class="invalid-feedback">
              <div *ngIf="form.new_password.errors.required" role="alert">
                {{ 'ACCOUNT.NEW_PASSWORD_REQURIED' | translate}}</div>
              <div *ngIf="form.new_password.errors.pattern && !form.new_password.errors.required" role="alert">
                Password must have a minimum of 12 characters, and including ones from at least 3 of these 4 categories:
                <br>
                • Uppercase letters
                <br>
                • Lowercase letters
                <br>
                • Numbers
                <br>
                • Special characters (for example: # & / ! *)
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="confirm_new_password"><span aria-hidden="true" class="form-field-required-marker">
                *</span> {{ 'ACCOUNT.CONFIRM_PASSWORD_LBL' | translate}}</label>
            <input id="confirm_new_password" [type]="hideConfirmPassword ? 'password' : 'text'" class="form-control"
              formControlName="confirm_new_password" role="textbox">
            <span class="eye-pos">
              <button type="button" class="eye-toggle" (click)="hideConfirmPassword = false"
                *ngIf="hideConfirmPassword" aria-label="Show confirmed password">
                <mat-icon class="material-symbols-outlined eye" aria-hidden="true">
                  visibility_off
                </mat-icon>
              </button>
              <button type="button" class="eye-toggle" (click)="hideConfirmPassword = true"
                *ngIf="!hideConfirmPassword" aria-label="Hide confirmed password">
                <mat-icon class="material-symbols-outlined eye" aria-hidden="true">
                  visibility
                </mat-icon>
              </button>
            </span>
            <div *ngIf="submitted && form.confirm_new_password.errors" class="invalid-feedback">
              <div *ngIf="form.confirm_new_password.errors.required" role="alert">
                {{ 'ACCOUNT.CONFIRM_PASSWORD_REQURIED' | translate}}</div>
              <div *ngIf="form.confirm_new_password.errors.mismatch" role="alert">Passwords must match
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
              <button class="btn btn-primary govuk-button button-sizer float-right col-12 col-sm-10 col-md-2"
                type="button" aria-label="Update password"
                (click)="onSubmit()">{{'COMMON.UPDATE' | translate}}</button>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>